import React, { useState } from 'react';
import classNames from 'classnames';
import css from './LandingPage.module.css';
import Icons from '../../components/Icons/Icons';
import { FormattedMessage } from 'react-intl';
import shape1 from '../../assets/landing/faq-shape1.png';
import shape2 from '../../assets/landing/faq-shape2.png';
import shape3 from '../../assets/landing/faq-shape3.png';

const faqKeys = Array.from({ length: 11 }, (_, i) => `question${i + 1}`);

function SectionFAQ(props) {
  const { intl } = props;
  const [activeIndex, setActiveIndex] = useState(null);

  const handleAccordionClick = index => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <div className={css.faqContentWrapper}>
      <span className={css.shape1}>
        <img src={shape1} alt="" />
      </span>
      <span className={css.shape2}>
        <img src={shape2} alt="" />
      </span>
      <span className={css.shape3}>
        <img src={shape3} alt="" />
      </span>
      <div className={css.faqContent}>
        <div className={css.sectionHead}>
          <h2>
            {/* <FormattedMessage id="LandingPage.FAQ.header" /> */}
            {intl.formatMessage({ id: 'LandingPage.FAQ.header' })}
          </h2>
        </div>
        {faqKeys.map((key, index) => (
          <div
            key={index}
            className={classNames(css.faqCard, {
              [css.activeFAQ]: activeIndex === index,
            })}
            onClick={() => handleAccordionClick(index)}
          >
            <div className={css.faqBody}>
              <span className={css.faqHeading}>
                <FormattedMessage id={`LandingPage.${key}.title`} />
              </span>
              {activeIndex === index && (
                <div className={css.faqDescription}>
                  <FormattedMessage id={`LandingPage.${key}.description`} />
                </div>
              )}
            </div>
            <span className={css.faqIcon}>
              {activeIndex === index ? <Icons name="upAngle" /> : <Icons name="angleDown" />}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default SectionFAQ;
